import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-profilei',
  templateUrl: './company-profilei.component.html',
  styleUrls: ['./company-profilei.component.scss']
})
export class CompanyProfileiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
